import React, { useContext, useState } from "react";
import { CommonContext } from "hooks/CommonContext";
import MessageComponent from "./components/MessageComponent";
import { getCurrentTime } from "utils/commonUtils";
import ChatInputWithEmojis from "./components/ChatInputWithEmojis";

const GeneralChat = () => {
  const {
    socketRef,
    userName,
    room_id,
    generalChatMessages,
    setGeneralChatMessages,
  } = useContext(CommonContext);
  const [inputText, setInputText] = useState("");

  function postMessage() {
    if (inputText.trim() !== "") {
      const current_time = getCurrentTime();
      setGeneralChatMessages((preData) => [
        ...preData,
        {
          username: userName,
          isOwnMessage: true,
          message: inputText,
          time: "" + current_time,
        },
      ]);
      socketRef.current.emit("new_message", {
        message: inputText,
        username: userName,
        room_id: room_id,
      });
      setInputText("");
    }
  }

  return (
    <React.Fragment>
      <div className="messages-chat-box p-4" id="messages">
        {generalChatMessages.map((item) => {
          return (
            <MessageComponent
              key={item.message + item.time + item.username}
              userName={item.username}
              sentTime={item.time}
              textMessage={item.message}
              isOwnMessage={item.isOwnMessage}
            />
          );
        })}
      </div>

      <ChatInputWithEmojis
        inputText={inputText}
        setInputText={setInputText}
        onSendMessage={postMessage}
      />
    </React.Fragment>
  );
};

export default GeneralChat;
